export default {"src":"/_next/static/media/brazil-flag.f36d2117.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};